;(function () {
  'use strict'

  angular
    .module('contrast.reports.filter')
    .factory('reportFilterService', reportFilterServiceFactory)

  function reportFilterServiceFactory(
    FILTER_GROUPS,
    VULNERABILITY_REPORT_TYPE
  ) {
    'ngInject'

    var _allOptionValue = 'All',
      _model = {
        type: VULNERABILITY_REPORT_TYPE.NEW,
        range: 'week',
        applications: [],
        servers: [],
        rules: [],
        isFromAppPage: false
      }

    // once the max has been reached, we no longer add the `servers` list to the url
    // instead we pass `serverEnvironments`
    const MAX_SERVER_COUNT = 100

    return {
      clear: clear,
      getType: getType,
      setType: setType,
      getRange: getRange,
      setRange: setRange,
      getApplications: getApplications,
      setApplications: setApplications,
      getServers: getServers,
      setServers: setServers,
      getServerEnvironments: getServerEnvironments,
      setServerEnvironments: setServerEnvironments,
      getRules: getRules,
      setRules: setRules,
      getIsFromAppPage: getIsFromAppPage,
      setIsFromAppPage: setIsFromAppPage,
      getAll: getAll,
      createRequest: createRequest,
      createParamsFromRequest: createParamsFromRequest,
      unwrapRequest: unwrapRequest
    }

    function clear() {
      _model.type = VULNERABILITY_REPORT_TYPE.NEW
      _model.range = 'week'
      _model.applications = []
      _model.servers = []
      _model.serverEnvironments = []
      _model.rules = []
      _model.isFromAppPage = false
    }

    function getAll() {
      return {
        type: _model.type,
        range: _model.range,
        applications: _model.applications,
        servers: _model.servers,
        serverEnvironments: _model.serverEnvironments,
        rules: _model.rules
      }
    }

    function createRequest(values) {
      if (!values) {
        values = getAll()
      }
      var form = {
        type: values.type,
        ruleSeverities: [],
        rules: [],
        allRules: false,
        applicationImportance: [],
        applications: [],
        allApplications: false,
        serverEnvironments: [],
        servers: [],
        allServers: false,
        appTags: [],
        serverTags: [],
        vulnTags: [],
        appVersions: [],
        securityStandards: []
      }
      var i = 0

      if (values.applications.length == 0) {
        form.allApplications = true
      } else {
        for (i = 0; i < values.applications.length; i++) {
          var app = values.applications[i]
          if (app.value == _allOptionValue) {
            form.allApplications = true
            form.applicationImportance = []
            form.applications = []
          } else {
            switch (app.group) {
              case FILTER_GROUPS.IMPORTANCE:
                form.applicationImportance.push(app.value)
                break

              case FILTER_GROUPS.APP_TAGS:
                form.appTags.push(app.value)
                break

              case FILTER_GROUPS.BUILD_NUMBERS:
                form.appVersions.push(app.value)
                break

              default:
                form.applications.push(app.value)
                break
            }
          }
        }
      }

      if (values.rules.length == 0) {
        form.allRules = true
      } else {
        for (i = 0; i < values.rules.length; i++) {
          var rule = values.rules[i]
          if (rule.value == _allOptionValue) {
            form.allRules = true
            form.ruleSeverities = []
            form.rules = []
            form.securityStandards = []
          } else {
            switch (rule.group) {
              case FILTER_GROUPS.SEVERITY:
                form.ruleSeverities.push(rule.value)
                break

              case FILTER_GROUPS.VULN_TAGS:
                form.vulnTags.push(rule.value)
                break

              case FILTER_GROUPS.SECURITY_STANDARDS:
                form.securityStandards.push(rule.value)
                break

              default:
                form.rules.push(rule.value)
                break
            }
          }
        }
      }

      if (values.servers.length == 0) {
        form.allServers = true
      } else if (values.servers.length >= MAX_SERVER_COUNT) {
        form.allServers = false
        form.serverEnvironments.push(values.serverEnvironments)
      } else {
        for (i = 0; i < values.servers.length; i++) {
          var server = values.servers[i]
          if (server.value == _allOptionValue) {
            form.allServers = true
            form.serverEnvironments = []
            form.servers = []
          } else {
            switch (server.group) {
              case FILTER_GROUPS.ENVIRONMENT:
                form.serverEnvironments.push(server.value)
                break

              case FILTER_GROUPS.SERVER_TAGS:
                form.serverTags.push(server.value)
                break

              default:
                form.servers.push(server.value)
                break
            }
          }
        }
      }

      return form
    }

    function unwrapRequest(
      view,
      select,
      allApplications,
      allServers,
      allRules
    ) {
      var filter = view.filter,
        viewInfo = JSON.parse(view.view),
        i = 0,
        changed = false

      var filterApps = [],
        filterServers = [],
        filterRules = []

      if (viewInfo.type) {
        setType(viewInfo.type)
      }

      if (filter.allApplications) {
        filterApps.push(allApplications)
      } else {
        for (i = 0; i < filter.applications.length; i++) {
          filterApps.push(
            _getItemFromSelect(select.applications, filter.applications[i])
          )
        }

        for (i = 0; i < filter.applicationImportance.length; i++) {
          filterApps.push(
            _getItemFromSelect(
              select.applications,
              filter.applicationImportance[i]
            )
          )
        }

        for (i = 0; i < filter.appTags.length; i++) {
          filterApps.push(
            _getItemFromSelect(select.applications, filter.appTags[i])
          )
        }

        for (i = 0; i < filter.appVersions.length; i++) {
          filterApps.push(
            _getItemFromSelect(select.applications, filter.appVersions[i])
          )
        }
      }

      if (_.includes(filterApps, undefined)) {
        filterApps = _.reject(filterApps, function (app) {
          return app == undefined
        })

        if (filterApps.length == 0) {
          filterApps.push(allRules)
        }

        changed = true
      }

      setApplications(filterApps)

      if (filter.allServers) {
        filterServers.push(allServers)
      } else {
        for (i = 0; i < filter.servers.length; i++) {
          filterServers.push(
            _getItemFromSelect(select.servers, filter.servers[i])
          )
        }

        for (i = 0; i < filter.serverEnvironments.length; i++) {
          filterServers.push(
            _getItemFromSelect(select.servers, filter.serverEnvironments[i])
          )
        }

        for (i = 0; i < filter.serverTags.length; i++) {
          filterServers.push(
            _getItemFromSelect(select.servers, filter.serverTags[i])
          )
        }
      }

      if (_.includes(filterServers, undefined)) {
        filterServers = _.reject(filterServers, function (server) {
          return server == undefined
        })

        if (filterServers.length == 0) {
          filterServers.push(allServers)
        }

        changed = true
      }

      setServers(filterServers)

      if (filter.allRules) {
        filterRules.push(allRules)
      } else {
        for (i = 0; i < filter.rules.length; i++) {
          filterRules.push(_getItemFromSelect(select.rules, filter.rules[i]))
        }

        for (i = 0; i < filter.ruleSeverities.length; i++) {
          filterRules.push(
            _getItemFromSelect(select.rules, filter.ruleSeverities[i])
          )
        }

        for (i = 0; i < filter.vulnTags.length; i++) {
          filterRules.push(_getItemFromSelect(select.rules, filter.vulnTags[i]))
        }

        for (i = 0; i < filter.securityStandards.length; i++) {
          filterRules.push(
            _getItemFromSelect(select.rules, filter.securityStandards[i])
          )
        }
      }

      if (_.includes(filterRules, undefined)) {
        filterRules = _.reject(filterRules, function (rule) {
          return rule == undefined
        })

        if (filterRules.length == 0) {
          filterRules.push(allRules)
        }

        changed = true
      }

      setRules(filterRules)

      return changed
    }

    function createParamsFromRequest(request) {
      var parametersForm = []

      angular.forEach(request, function (value, key) {
        if (angular.isArray(value)) {
          if (value.length > 0) {
            parametersForm.push({ name: key, value: value.join(',') })
          }
        } else {
          parametersForm.push({ name: key, value: value })
        }
      })

      return parametersForm
    }

    function getType() {
      return _model.type
    }

    function setType(type) {
      return (_model.type = type)
    }

    function getRange() {
      return _model.range
    }

    function setRange(range) {
      return (_model.range = range)
    }

    function getApplications() {
      return _model.applications
    }

    function setApplications(apps) {
      return (_model.applications = apps)
    }

    function getServers() {
      return _model.servers
    }

    function setServers(servers) {
      return (_model.servers = servers)
    }

    function getServerEnvironments() {
      return _model.serverEnvironments
    }

    function setServerEnvironments(serverEnvironments) {
      return (_model.serverEnvironments = serverEnvironments)
    }

    function getRules() {
      return _model.rules
    }

    function setRules(rules) {
      return (_model.rules = rules)
    }

    function getIsFromAppPage() {
      return _model.isFromAppPage
    }

    function setIsFromAppPage(value) {
      return (_model.isFromAppPage = value)
    }

    function _getItemFromSelect(select, value) {
      return _.find(select, function (item) {
        return item.value == value
      })
    }
  }
})()
